module.exports = __webpack_public_path__ + "img/supplier.0ed5f173.png";